export default "__VITE_ASSET__UKBzGZtT__"